export default "__VITE_ASSET__DvJYdBLi__"